import React from 'react';
import { Popover, PopoverTrigger, PopoverContent } from '@/components/ui/popover';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

const PRESETS = [
  '#0F3D2E', '#2F6F5E', '#0F766E', '#14B8A6', '#84CC16',
  '#22C55E', '#0EA5A4', '#0284C7', '#7C3AED', '#F59E0B',
  '#EF4444', '#111827',
];

export const ColorPicker = ({ value, onChange, testid }) => (
  <Popover>
    <PopoverTrigger asChild>
      <Button variant="outline" type="button" data-testid={testid} className="justify-start gap-2 w-full">
        <span className="inline-block size-5 rounded border" style={{ background: value }} />
        <span className="font-mono text-xs">{value || '#000000'}</span>
      </Button>
    </PopoverTrigger>
    <PopoverContent className="w-64 p-3 space-y-3">
      <div className="grid grid-cols-6 gap-2">
        {PRESETS.map(c => (
          <button
            type="button"
            key={c}
            className="size-7 rounded border hover:scale-110 transition-transform"
            style={{ background: c }}
            onClick={() => onChange?.(c)}
            aria-label={c}
          />
        ))}
      </div>
      <Input value={value || ''} onChange={(e) => onChange?.(e.target.value)} placeholder="#0F766E" className="font-mono" />
    </PopoverContent>
  </Popover>
);
